import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-visionbook-workshop-group.jpg`;
const ALT = "Five women gathered around a kitchen table at night, working together on their Vision Books.";
const IMG2 = `${A}/blueprint4joy-visionbook-thisfacehelped.jpg`;
const ALT2 = "A handwritten Vision Book page titled 'This face helped,' with a photo of a grandmother and granddaughter and layered handwritten reflections.";

export function MaybeThisSoundsFamiliar() {
  return (
    <section data-testid="vbw-maybe-familiar-section" className="relative overflow-hidden bg-white">
      {/* Partial editorial split: photograph beside the opening lines,
          both at native aspect ratio (zero hard crop) so all five
          participants stay fully visible edge to edge. */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[36px] md:pt-[47px] reveal">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <div className="relative w-full" style={{ aspectRatio: "1152 / 896" }}>
              <FeatheredImage
                src={IMG}
                alt={ALT}
                testId="vbw-maybe-familiar-image"
                objectPosition="center"
                featherLeft={8}
                featherRight={8}
                featherTop={8}
                featherBottom={8}
                className="absolute inset-0"
              />
            </div>
          </div>

          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
              Maybe This Sounds Familiar
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[44px] leading-[1.1] tracking-tight text-[#1C1917] mb-3">
              Maybe you don&rsquo;t need better goals.
            </h2>
            <p className="font-display text-xl md:text-2xl text-[#159E9A] italic leading-snug mb-7">
              Maybe you need a little more clarity.
            </p>
            <div className="space-y-4 text-[20px] md:text-[22px] leading-relaxed text-[#57534E]">
              <p>You know something wants to change.</p>
              <p>You just can&rsquo;t quite name it.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Remaining locked copy continues below the image/text composition.
          Left-aligned with the upper composition (same outer container) and
          widened to ~58% of the content column so it reads as a deliberate
          editorial continuation. A second photograph sits upper-right,
          beside the opening continuation line, feathered per the shared
          FeatheredImage treatment (no hard crop, edge-only feather). */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[31px] md:pt-[36px] pb-[36px] md:pb-[47px] reveal">
        <div className="grid grid-cols-1 lg:grid-cols-[36%_1fr] gap-10 lg:gap-14 items-start">
          <div>
            <div className="space-y-4 text-[20px] md:text-[22px] leading-relaxed text-[#57534E]">
              <p>Maybe you&rsquo;ve spent years building the life everyone expected.</p>
              <p>
                Maybe you&rsquo;ve accomplished things you&rsquo;re proud of and
                still find yourself wondering if something is missing.
              </p>
              <p>Maybe you&rsquo;re grieving.</p>
              <p>Maybe you&rsquo;re dreaming.</p>
              <p>
                Maybe you&rsquo;re standing at a crossroads and aren&rsquo;t sure
                which direction feels true.
              </p>
              <p>It isn&rsquo;t because you&rsquo;ve failed.</p>
              <p>It isn&rsquo;t because you aren&rsquo;t trying hard enough.</p>
              <p>Sometimes life simply becomes so busy that we stop hearing ourselves.</p>
              <p className="text-[#1C1917]">
                A Vision Book creates the space to notice what has been
                quietly waiting for your attention.
              </p>
            </div>

            <div className="mt-9 space-y-1">
              <p className="font-display text-2xl md:text-3xl text-[#57534E] leading-snug">
                Maybe you don&rsquo;t need all the answers.
              </p>
              <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug">
                Maybe you simply need a place to begin listening.
              </p>
            </div>
          </div>

          {/* ThisFaceHelped increased to ~125% of its prior (6-of-12,
              ~572px) displayed size via a 36%/1fr column split (~715px at
              max-w-7xl) — single image, zero crop, native 1500:2000 aspect
              ratio preserved. */}
          <div>
            <div className="relative w-full max-w-sm mx-auto lg:max-w-none" style={{ aspectRatio: "1500 / 2000" }}>
              <FeatheredImage
                src={IMG2}
                alt={ALT2}
                testId="vbw-maybe-familiar-image-2"
                objectPosition="center"
                featherLeft={10}
                featherRight={10}
                featherTop={10}
                featherBottom={10}
                className="absolute inset-0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
